export function groupBy<TRow extends Record<keyof TRow, unknown>, TKey>(
  collection: TRow[],
  selector: (item: TRow) => TKey
) {
  const result = new Map<TKey, TRow[]>();
  for (const row of collection) {
    const values = result.get(selector(row)) ?? [];
    values.push(row);
    result.set(selector(row), values);
  }
  return result;
}
